import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLetterACircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="letter-a-circle"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M8.14844 16L11.1484 7.54492H12.8535L15.8535 16H14.2715L13.5625 13.8145H10.4336L9.73047 16H8.14844ZM11.9512 9.11523L10.8145 12.6484H13.1875L12.0508 9.11523H11.9512Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLetterACircle;
